import { Link } from 'react-router-dom';
import { novels } from '@/mocks/novels';

export default function FeaturedNovels() {
  const featured = novels.filter((n) => n.isRecommended).slice(0, 4);

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">编辑精选 · 品质之选</p>
          </div>
          <Link
            to="/category/urban-romance"
            className="text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
          {featured.map((novel, index) => (
            <Link
              key={novel.id}
              to={`/article/${novel.id}`}
              className="group bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={novel.coverImage}
                  alt={novel.title + ' - 都市情感小说推荐'}
                  title={novel.title + ' - 都市禁忌情感小说'}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading={index === 0 ? undefined : undefined}
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 bg-primary-100 text-primary-700 rounded-full whitespace-nowrap">
                    {novel.category}
                  </span>
                  {novel.isHot && (
                    <span className="text-xs px-2 py-0.5 bg-accent-100 text-accent-800 rounded-full whitespace-nowrap">
                      热门
                    </span>
                  )}
                </div>
                <h3 className="font-heading text-base text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {novel.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
                  {novel.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{novel.author}</span>
                  <span className="flex items-center gap-1 text-xs text-accent-600">
                    <i className="ri-star-fill text-xs"></i>
                    {novel.rating}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}